import { SearchInput } from "./SearchInput";
import React from "react";
import { useRouteMatch, useLocation } from "react-router-dom";
import { Row, Menu } from "antd";
import { Link } from "react-router-dom";
import { useState } from "react";

export const ListMenu = ({ search, setSearch }) => {
  const { url } = useRouteMatch();
  const location = useLocation();
  const [current, setCurrent] = useState(
    location.pathname === `${url}/inativos` ? "inactive" : "active",
  );
  const onClick = (e) => {
    setCurrent(e.key);
  };

  return (
    <Row justify="space-between" style={{ alignItems: "center" }}>
      <Menu
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        disabledOverflow={true}
      >
        <Menu.Item key="active">
          <Link to={`${url}`}>Ativos</Link>
        </Menu.Item>
        <Menu.Item key="inactive">
          <Link to={`${url}/inativos`}>Inativos</Link>
        </Menu.Item>
      </Menu>

      <SearchInput searchQuery={search} setSearchQuery={setSearch} />
    </Row>
  );
};
